import { render, staticRenderFns } from "./AssistantEdit.vue?vue&type=template&id=615d02c2"
import script from "./AssistantEdit.vue?vue&type=script&lang=js"
export * from "./AssistantEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports